// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__390RB","ranges":"BmiRanges_ranges__ePFkP"};